import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { AbstractLayerDetailComponent } from '@connect-services/client/components/project-settings/abstract-layer-detail.component';
import { ProjectSettingsLayerDetailTemplateComponent } from '@connect-services/client/components/project-settings/project-settings-layer-detail-template/project-settings-layer-detail-template.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProjectSettingsLayerDetailTemplateComponent, TranslocoPipe],
    selector: 'app-flux-layer-detail',
    templateUrl: './flux-layer-detail.component.html',
})
export class FluxLayerDetailComponent extends AbstractLayerDetailComponent {
    public constructor() {
        super();
    }
}
